<template>
  <div>
    <img
      v-for="item in getEnhancedBrandLogos"
      :key="item.id"
      :data-src="item.Url"
      class="cld-responsive productDescription__BrandLogo__image"
      :alt="item.Title"
      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters("enhancedproduct", ["getEnhancedProductData"]),
    getEnhancedBrandLogos() {
      var product = this.getEnhancedProductData;
      return product && product.Series && product.Series.Brands
        ? product.Series.Brands
        : null;
    }
  }
};
</script>

<style lang="scss" scoped>
.productDescription__BrandLogo {
  &__image {
    padding-top: 10px;
    padding-bottom: 10px;

    @include media-breakpoint-up(sm) {
      padding-top: 5px;
      padding-bottom: 5px;
      padding-right: 20px;
    }
  }
}
</style>
